var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "57895A74-D35A-4EC6-9966-F0BEB9133FED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.32424242,23 L2.32424242,15.84375 L0,15.84375 L0,13 L2.32424242,13 L2.32424242,10.759375 C2.32424242,8.325 3.76666667,7 5.87272727,7 C6.88181818,7 7.74848485,7.078125 8,7.1125 L8,9.65625 L6.53939394,9.65625 C5.39393939,9.65625 5.17272727,10.21875 5.17272727,11.040625 L5.17272727,13 L7.75757576,13 L7.4030303,15.84375 L5.17272727,15.84375 L5.17272727,23",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Central-Admin-_-Company-Deteails-/-Branches-add",
    transform: "translate(-405.000000, -1522.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-64",
    transform: "translate(241.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(48.000000, 1328.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(116.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "facebook-f",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;